import React, { useState, useEffect } from "react";
import "./styles.css";
import MultiSelect from "react-multi-select-component";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import axios from 'axios';

const SelectAll = (props) => {
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState(props?.options || []);
  const [error, setError] = useState(null);

  // Configure axios instance
  const api = axios.create({
    baseURL: 'https://jobmanagement-497524552274.us-central1.run.app'
  });

  // Add auth token to requests
  api.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  useEffect(() => {
    const fetchJobStatuses = async () => {
      try {
        const response = await api.get('/jobs/status-count');
        
        // Transform API response to MultiSelect options format
        const statusOptions = Object.entries(response.data).map(([status, count]) => ({
          label: status.replace(/_/g, ' ')
            .split(' ')
            .map(word => word.charAt(0) + word.slice(1).toLowerCase())
            .join(' '),
          value: status,
          count: count
        }));

        setOptions(statusOptions);
      } catch (err) {
        console.error('Error fetching job statuses:', err);
        setError(err.message);
      }
    };

    // Only fetch if no options were provided as props
    if (!props?.options || props.options.length === 0) {
      fetchJobStatuses();
    }
  }, [props?.options]);

  const valueRenderer = (selected) => {
    return (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <FilterAltOutlinedIcon style={{color: '#0D5C75'}}/>
        <div style={{
          color: '#888888',
          fontSize: '15px',
          marginLeft: '8px'
        }}>
          {selected.length > 0 
            ? `${selected.length} Status${selected.length > 1 ? 'es' : ''} Selected`
            : 'Filter By Job Status'
          }
        </div>
      </div>
    );
  };

  const optionRenderer = ({ label, count }) => {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        padding: '2px 0'
      }}>
        <span>{label}</span>
        {count !== undefined && (
          <span style={{
            color: '#666',
            fontSize: '0.9em',
            marginLeft: '8px'
          }}>
            ({count})
          </span>
        )}
      </div>
    );
  };

  const handleChange = (selectedOptions) => {
    setSelected(selectedOptions);
    if (props.onChange) {
      props.onChange(selectedOptions);
    }
  };

  return (
    <div>
      <MultiSelect
        options={options}
        selected={selected}
        onChange={handleChange}
        valueRenderer={valueRenderer}
        optionRenderer={optionRenderer}
        disableSearch={true}
        selectAll={true}
        selectAllLabel="Select All"
        hasSelectAll={true}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: '#f5f5f5',    // Hover background
            primary: '#0D5C75',      // Selected items & checkboxes
            neutral20: '#ddd',       // Border color
            neutral30: '#ccc',       // Border hover color
            neutral80: '#333',       // Text color
          },
          spacing: {
            ...theme.spacing,
            baseUnit: 4,            // Adjust spacing
            menuGutter: 8,          // Dropdown menu spacing
          },
        })}
        className="multi-select-container"
      />
      
      {error && (
        <div style={{
          color: 'red',
          fontSize: '0.8em',
          marginTop: '4px'
        }}>
          Error loading status options: {error}
        </div>
      )}
    </div>
  );
};

export default SelectAll;